export default defineNuxtPlugin({
  async setup() {
    // Если в query есть данные VK, то фетчим сессию по данным из квери
    const route = useRoute()
    const vkUserId = route.query.vk_user_id as string | undefined

    if (!vkUserId) {
      return {
        provide: {
          vkBridge: null,
        },
      }
    }

    let vkBridge = null

    if (import.meta.client) {
      // Динамически импортируем vk-bridge только когда нужно
      const { default: bridge } = await import('@vkontakte/vk-bridge')

      // Отправляет событие инициализации нативному клиенту
      bridge.send('VKWebAppInit')

      vkBridge = bridge
    }

    return {
      provide: {
        vkBridge,
      },
    }
  },
})
